<app-navbar
  [headerText]="'Müştərilər'"
  [buttons]="navButtons"
  [dataLoading]="_customersService.dataLoading()"
></app-navbar>

<div class="container mt-6">
  <ag-table
    [tableData]="_dataService.customers()"
    [colDefs]="colDefs"
    [tableHeight]="'calc(100vh - 130px)'"
    (rowClicked)="rowClicked($event)"
  ></ag-table>
</div>